import { take, cancel, fork, select, call, put } from 'redux-saga/effects';
import { callApi } from "./callApi";
import config from '../../config/config';
import { showNotification } from '../actionCreators/notification';
import { updateSelectedMembersSuccess } from '../actionCreators/selectDownline';
import { getCurrentClubAdminAccount } from '../selectors';
import actionTypes from '../actionTypes';

function* updateSelectedMembers({ agentId, playerIdList }) {
  try {
    const { token } = yield select(getCurrentClubAdminAccount);
    const affiliateId = agentId;
    const players = playerIdList;
    const action = 'overwrite';
    const response = yield call(callApi, `${config.API_URL}/club/playersParentAgentUpdate`, 'POST', {
      affiliateId,
      players,
      action,
      token,
    });
    yield put(updateSelectedMembersSuccess());
    yield put(showNotification({ message: response.data.result.message }));
  } catch (e) { }
}

function* watchUpdateSelectedMembers() {
  let forked = null;
  while (true) {
    const action = yield take(actionTypes.UPDATE_SELECTED_MEMBERS);
    if (forked) yield cancel(forked);
    forked = yield fork(updateSelectedMembers, action);
  }
}

export default watchUpdateSelectedMembers;